import {
  ActionAddSavedSetting,
  ActionClearSavedSettings,
  ActionRemoveSavedSetting,
  ActionSetSavedSettings,
  ActionTypesSavedSettingsE,
  ISavedMinerSetting,
} from "./actionTypes";

export const setSavedSettings = (
  savedSettings: ISavedMinerSetting[]
): ActionSetSavedSettings => {
  return {
    type: ActionTypesSavedSettingsE.SET_SAVED_SETTINGS,
    payload: {
      savedSettings,
    },
  };
};

export const addSavedSetting = (
  newSavedSetting: ISavedMinerSetting
): ActionAddSavedSetting => {
  return {
    type: ActionTypesSavedSettingsE.ADD_SAVED_SETTINGS,
    payload: {
      newSavedSetting,
    },
  };
};

export const removeSavedSetting = (
  payload: ISavedMinerSetting["cloned_miner"]
): ActionRemoveSavedSetting => {
  return {
    type: ActionTypesSavedSettingsE.REMOVE_SAVED_SETTING,
    payload,
  };
};

export const clearSavedSettings = (): ActionClearSavedSettings => {
  return {
    type: ActionTypesSavedSettingsE.SET_SAVED_SETTINGS,
  };
};
